<template>
  <section>
    <div class="businessViewTitle">
      <h1 class="header">{{ title }}</h1>
      <p v-if="showReturn" @click="goBack">
        <el-button plain size="small" style="font-size: 14px;">返回</el-button>
      </p>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    title: String,
    showReturn: Boolean
  },
  data() {
    return {};
  },
  watch: {},
  components: {},
  async mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  created() {}
};
</script>
<style lang="less" scope>
.businessViewTitle {
  display: flex;
  justify-content: space-between;
  padding: 0px 0px 16px 0px;
  align-items: center;
  p {
    margin: 0;
  }
  .header {
    margin: 0px;
    font-size: 20px;
    color: #4a4a4a;
  }
}
</style>
